// 先去掉HelpModuleFn、FormModuleFn、FillAndSignFn、ConvertModuleFn、AddModuleFnSaveFile
// import ConvertModuleFn from './convert/index';
import FwConvertModuleFn from './fwConvert/index';
import FwHelpModuleFn from './fwHelp/index';
import {TooltipModule} from './comments/index';
import {newWidgats} from './fwModule/index';
import FileModuleFn from './file/index';
import FormModuleFn from './form/index';
import OrganizeModuleFn from './organize/index';
import HelpModuleFn from './help/index'
import PaperCheckModuleFn from './PaperCheck';
import EsignCNModuleFn from './esignCN/index'
// import FillAndSignFn from './fill_sign/index'
// import { MobileContainerFn } from './mobile/index';
// import FoxitEsignModuleFn from './FoxitEsign/index';
import ManageSignatureContainer from './manage_signature/index';
import ApplyAllSignatureContainer from './apply_all_signature/index';
import DocumentStatusContainer from './document_status/index';
import CloseSignContainer from './close_sign/index';
import ProtectPdfSignContainer from './protect_pdf_sign/index';
import HomePdfSignContainer from './home_pdf_sign/index';
// import { MobileContainerFn } from './mobile/index';
import { AddModuleFn } from './open/index'; //RemoveModuleFn,
// import { AddModuleFn as AddModuleFnSaveFile } from './save/index';
//import { AddModuleFn as AddModuleFnComments} from './comments/index';
// import { AddModuleFn as AddModuleFnFloatBar} from './float_bar/index';
import { AddModuleFn as FloatPageNumberFn} from './FloatPageNumber/FloatPageNumber';
// import { DropdownGroupController } from "./ViewerComponents/index";
import { ViewerTemplateModule } from "./ViewerTemplate/viewer.template";
import bindCallbacks from './callbacks';
import {
  FILE_SELECTOR_EXTERNAL,
  //, COMMON_BUTTONS, COMMON_BUTTONS_MOBILE
} from './constants/index';
// import fwTooltipLayer from './organize/fw_tooltipLayer'; // !用tooltipLayer来处理侧边栏的hover效果，有点问题（再考虑下）

import { updateTemplateText } from "./TextAndTooltip/TextAndTooltip";
import {isMobile} from 'Utils/device';
export function bindViewerButtons(callback, error) {
  let callbacks = [];
  let cache = [];
  //!自定义按钮的绑定事件(文件转换、创建新的PDF文件包)
  cache = bindCallbacks(FILE_SELECTOR_EXTERNAL, callback, error);
  callbacks.push(...cache);
  //cache = bindCallbacks(SIDEBAR_COMMENT_LIST, callback, error, true);
  //callbacks.push(...cache);
  // if (window.deviceInfo && window.deviceInfo.isMobile) {
  //   cache = bindCallbacks(COMMON_BUTTONS_MOBILE, callback, error, true);
  //   callbacks.push(...cache);
  // } else {
  //   cache = bindCallbacks(COMMON_BUTTONS, callback, error, true);
  //   callbacks.push(...cache);
  // }
  return callbacks;
}

// TODO FOXIT 去除所有手机端插件：  MobileContainerFn
let customUIFns = [];
// customUIFns.push(fwTooltipLayer);
customUIFns.push(TooltipModule);
customUIFns.push(newWidgats); // TODO FOXIT 测试在本地src下注册组件
customUIFns.push(FileModuleFn);
// customUIFns.push(ConvertModuleFn); // TODO FOXIT 先隐藏转换功能
customUIFns.push(ViewerTemplateModule);

if (isMobile) {
} else {
  customUIFns.push(FwConvertModuleFn);
  customUIFns.push(FwHelpModuleFn);
  customUIFns.push(FloatPageNumberFn);
  customUIFns.push(FormModuleFn);
  customUIFns.push(OrganizeModuleFn);
  customUIFns.push(AddModuleFn);
  customUIFns.push(EsignCNModuleFn);
  // customUIFns.push(AddModuleFnSaveFile);
  //customUIFns.push(AddModuleFnComments);
  // TODO FOXIT 页面多了一个float-bottom-bar
  // customUIFns.push(AddModuleFnFloatBar);
  // customUIFns.push(FillAndSignFn);
  // customUIFns.push(FoxitEsignModuleFn);
  customUIFns.push(ManageSignatureContainer);
  customUIFns.push(ApplyAllSignatureContainer);
  customUIFns.push(DocumentStatusContainer);
  customUIFns.push(CloseSignContainer);
  customUIFns.push(ProtectPdfSignContainer);
  customUIFns.push(HomePdfSignContainer);
  customUIFns.push(EsignCNModuleFn);
  customUIFns.push(HelpModuleFn);
  customUIFns.push(PaperCheckModuleFn);
}
customUIFns.push(TooltipModule);
customUIFns.push(updateTemplateText);


export default customUIFns;
